// src/pages/legal/PrivacyPage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white/80 pb-24">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10 px-4 py-4 flex items-center">
        <button
          onClick={() => navigate(-1)}
          className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/5 transition-colors"
        >
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <h1 className="text-lg font-bold ml-2 tracking-widest text-cyan-400 drop-shadow-[0_0_8px_rgba(34,211,238,0.5)]">
          プライバシーポリシー
        </h1>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8 space-y-8 text-sm leading-relaxed">
        
        <p className="text-white/50 text-right">最終更新日：2025年7月9日</p>

        {/* 基本方針 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">基本方針</h2>
          <p>
            株式会社Dig-Dim（以下「当社」といいます）<span className="text-pink-400 text-xs">※正式名称に変更してください</span> は、音楽プラットフォーム「Dig-Dim」の提供にあたり、利用者の個人情報の重要性を認識し、個人情報保護法その他の関連法令を遵守し、適切に取り扱うことをお約束します。
          </p>
        </section>

        {/* 第1条 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">第1条（収集する情報）</h2>
          <p className="mb-4">当社は、本サービスの提供にあたり、以下の情報を収集します。</p>
          <div className="space-y-4">
            <div>
              <strong className="text-white">登録情報</strong>
              <p className="mt-1">メールアドレス、表示名、ユーザー種別、音楽の好み、音の要素、および商品の配送や本人確認に付随する住所情報（郵便番号、都道府県、市区町村、番地等）。</p>
            </div>
            <div>
              <strong className="text-white">決済情報</strong>
              <p className="mt-1">クレジットカード情報自体は Stripe, Inc. により安全に処理され、当社サーバーには保存されません。当社は、Stripeから発行された決済用ID、カードブランド、有効期限、末尾4桁のみを保持します。</p>
            </div>
            <div>
              <strong className="text-white">利用情報</strong>
              <p className="mt-1">アクセスログ、IPアドレス、Cookie情報、閲覧履歴、お気に入り情報、Resonance（投げ銭）やグッズの購入・クリック履歴、NFCチェックイン履歴等。</p>
            </div>
            <div>
              <strong className="text-white">デバイス情報</strong>
              <p className="mt-1">端末の種類、OS、ブラウザの種類等。</p>
            </div>
          </div>
        </section>

        {/* 第2条 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">第2条（利用目的）</h2>
          <p className="mb-4">当社は、収集した個人情報を以下の目的で利用します。</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>本サービスの提供、運営、および機能改善。</li>
            <li>商品の配送、イベントの予約管理、および取引の遂行。</li>
            <li>利用者へのお知らせ、カスタマーサポートの提供。</li>
            <li>地域別、ジャンル別の統計データの作成および分析。</li>
            <li>パーソナライズされた音楽・イベント・アーティストの推薦。</li>
            <li>決済処理、請求管理、および不正利用の防止。</li>
            <li>その他、法令に基づく対応。</li>
          </ul>

          {/* ★ ファンエンゲージメント分析 — 強調ブロック */}
          <div className="mt-6 bg-pink-500/10 border border-pink-500/40 rounded-lg p-4">
            <div className="flex items-start gap-2">
              <i className="ri-bar-chart-2-line text-pink-400 mt-0.5 shrink-0 text-base"></i>
              <div>
                <strong className="text-pink-300 text-sm">
                  ファンエンゲージメントデータの分析・提供（Analytics機能）
                </strong>
                <p className="mt-2 text-white/70 text-xs leading-relaxed">
                  本サービスのコア機能である「Analytics（ファン深度の可視化）」の提供を目的として、利用者のお気に入り登録、Resonance（投げ銭）、NFCチェックイン・来場履歴、リンク再生等の利用行動を集計・スコアリングし、当該利用者が支持するMaker（アーティスト）またはNode（店舗・会場）のダッシュボードに、以下の<strong className="text-white">統計情報（個人を特定しない集計・スコア形式）</strong>として提供します。
                </p>
                <ul className="mt-3 space-y-1 text-white/60 text-xs pl-4 list-disc">
                  <li>深度スコア（Resonance数、来場回数、リンク再生数等から算出した支持度の指標）</li>
                  <li>NFCチェックイン・来場履歴（来場回数、最終来場日等の統計値）</li>
                  <li>Resonance（投げ銭）の累計金額・回数</li>
                  <li>お気に入り登録日・継続期間</li>
                  <li>グッズ購入履歴（購入点数・金額の統計値）</li>
                </ul>
                <p className="mt-3 text-white/50 text-xs">
                  ※ 上記データの第三者提供の詳細は<strong className="text-white/70">第3条</strong>をご参照ください。<br/>
                  ※ 利用者は、以下の手順でいつでも本機能によるデータ提供をオプトアウトすることができます。
                </p>
                {/* オプトアウト手順 — 第2条 */}
                <div className="mt-3 bg-black/30 border border-white/10 rounded-lg p-3">
                  <p className="text-white/60 text-xs font-bold mb-2 flex items-center gap-1">
                    <i className="ri-settings-3-line text-cyan-400"></i>
                    オプトアウト手順
                  </p>
                  <ol className="text-white/50 text-xs space-y-1 pl-4 list-decimal">
                    <li>画面下部のナビゲーションから <strong className="text-white/70">「マイページ」</strong> を開く</li>
                    <li><strong className="text-white/70">「設定」</strong> タブを選択する</li>
                    <li>「<strong className="text-white/70">DATA CONSENT</strong>」セクションを確認する</li>
                    <li><strong className="text-white/70">「Analytics データ提供を無効にする」</strong> ボタンをタップして同意を取り消す</li>
                  </ol>
                  <p className="mt-2 text-white/40 text-xs">※ オプトアウト後も、既に提供済みのデータが即時削除されるわけではありません。削除を希望する場合は第7条のお問い合わせ窓口までご連絡ください。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 第3条 */}
        <section className="bg-white/5 border border-pink-500/30 p-6 rounded-lg relative overflow-hidden">
          <div className="absolute top-0 left-0 w-1 h-full bg-pink-500"></div>
          <h2 className="text-pink-400 font-bold text-lg mb-4 flex items-center gap-2">
            <i className="ri-error-warning-line"></i>第3条（第三者提供）★重要
          </h2>
          <p className="mb-4">当社は、以下の場合を除き、利用者の事前の同意なく個人情報を第三者に提供しません。</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong className="text-white">販売者への提供（CtoC取引の遂行）：</strong><br/>
              利用者が本サービスを通じて商品（グッズ）やイベントチケットを購入した場合、当該取引の遂行（商品の発送、イベントの受付・運営等）に必要な範囲で、利用者の個人情報（氏名、配送先住所、連絡先等）を、対象商品の販売者またはイベント主催者（MakerまたはNode）に提供します。
            </li>
            <li>
              <strong className="text-white">業務委託先への提供：</strong><br/>
              決済処理、本人確認、または不正検知のために決済代行業者（Stripe, Inc.）に情報を提供する場合。また、当社が商品の配送を委託する業者に対し、配送に必要な情報を提供する場合。
            </li>

            {/* ★ ファンエンゲージメント統計情報の提供 */}
            <li className="bg-pink-500/10 border border-pink-500/40 rounded-lg p-4 list-none -mx-1">
              <div className="flex items-start gap-2">
                <i className="ri-bar-chart-2-line text-pink-400 mt-0.5 shrink-0"></i>
                <div>
                  <strong className="text-pink-300">Maker・Nodeへのエンゲージメント統計情報の提供（Analytics機能）：</strong><br/>
                  <p className="mt-2 text-white/70">
                    本サービスは、ファンとアーティスト・会場との関係性を可視化する「Analytics（ファン深度の可視化）」機能を提供しています。この機能の一環として、当社は、本サービス内のファンエンゲージメント向上を目的として、特定のMaker（アーティスト）またはNode（店舗・会場）に対し、当該MakerまたはNodeをお気に入り登録等している利用者の以下の<strong className="text-white">利用統計情報（個人を特定しない集計・スコア形式）</strong>を提供します。
                  </p>
                  <ul className="mt-3 space-y-1 text-white/60 text-xs pl-4 list-disc">
                    <li>深度スコア（Resonance数、来場回数、リンク再生数等から算出した支持度の指標）</li>
                    <li>NFCチェックイン・来場履歴（来場回数、最終来場日等の統計値）</li>
                    <li>Resonance（投げ銭）の累計金額・回数</li>
                    <li>お気に入り登録日・継続期間</li>
                    <li>グッズ購入履歴（購入点数・金額の統計値）</li>
                  </ul>
                  <p className="mt-3 text-white/50 text-xs">
                    ※ 上記情報は、当該MakerまたはNodeのダッシュボード（Analytics画面）においてのみ閲覧可能であり、第三者への再提供は禁止されています。<br/>
                    ※ 本項の提供目的は第2条のファンエンゲージメント分析と同一であり、両条は一体として適用されます。<br/>
                    ※ 利用者は、以下の手順でいつでも本機能によるデータ提供をオプトアウトすることができます。
                  </p>
                  {/* オプトアウト手順 — 第3条 */}
                  <div className="mt-3 bg-black/30 border border-white/10 rounded-lg p-3">
                    <p className="text-white/60 text-xs font-bold mb-2 flex items-center gap-1">
                      <i className="ri-settings-3-line text-cyan-400"></i>
                      オプトアウト手順
                    </p>
                    <ol className="text-white/50 text-xs space-y-1 pl-4 list-decimal">
                      <li>画面下部のナビゲーションから <strong className="text-white/70">「マイページ」</strong> を開く</li>
                      <li><strong className="text-white/70">「設定」</strong> タブを選択する</li>
                      <li>「<strong className="text-white/70">DATA CONSENT</strong>」セクションを確認する</li>
                      <li><strong className="text-white/70">「Analytics データ提供を無効にする」</strong> ボタンをタップして同意を取り消す</li>
                    </ol>
                    <p className="mt-2 text-white/40 text-xs">※ オプトアウト後も、既に提供済みのデータが即時削除されるわけではありません。削除を希望する場合は第7条のお問い合わせ窓口までご連絡ください。</p>
                  </div>
                </div>
              </div>
            </li>

            <li>法令に基づく場合。</li>
            <li>人の生命、身体または財産の保護のために必要がある場合。</li>
          </ul>
        </section>

        {/* 第4条 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">第4条（外部サービスの利用）</h2>
          <p className="mb-2">本サービスは、以下の外部サービスを利用しています。</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong className="text-white">Supabase（データベース・認証）</strong><br/>
              <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:underline">https://supabase.com/privacy</a>
            </li>
            <li>
              <strong className="text-white">Stripe（決済処理）</strong><br/>
              <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:underline">https://stripe.com/privacy</a>
            </li>
          </ul>
        </section>

        {/* 第5条 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">第5条（Cookieの使用）</h2>
          <p>
            本サービスは、利便性向上およびサービス改善、認証の維持のためにCookie（クッキー）を使用します。利用者はブラウザの設定でCookieを無効化することができますが、その場合、本サービスの一部またはすべての機能が利用できなくなる場合があります。
          </p>
        </section>

        {/* 第6条 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">第6条（セキュリティ）</h2>
          <p>
            当社は、個人情報の漏えい、滅失またはき損の防止その他の個人情報の安全管理のために、データの暗号化（SSL/TLS通信）やアクセス制限等の必要かつ適切な措置を講じます。ただし、インターネット通信の性質上、完全な安全性を保証するものではありません。
          </p>
        </section>

        {/* 第7条 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">第7条（個人情報の開示・訂正・削除）</h2>
          <p className="mb-2">利用者は、当社に対して自己の個人情報の開示、訂正、追加、削除、利用停止を請求することができます。請求を希望される場合は、以下の連絡先までお問い合わせください。</p>
          <div className="bg-black/30 p-4 rounded border border-white/5">
            <strong className="text-white">お問い合わせ窓口</strong><br/>
            メールアドレス：support@dig-dim.app <span className="text-pink-400 text-xs">※実際のメールアドレスに変更してください</span>
          </div>
        </section>

        {/* 第8条 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">第8条（プライバシーポリシーの変更）</h2>

          <div className="space-y-4">
            <div>
              <p className="font-bold text-white/90 mb-1">8.1 変更の権限</p>
              <p>
                当社は、法令の改正、サービス内容の変更、その他必要に応じて本ポリシーを変更することができます。
              </p>
            </div>

            <div>
              <p className="font-bold text-white/90 mb-1">8.2 重要な変更の通知方法</p>
              <p className="mb-3">
                個人情報の利用目的の追加・変更、第三者提供の範囲の拡大など、利用者の権利に重大な影響を与える変更を行う場合は、変更の効力発生日の<strong className="text-white">14日前までに</strong>、以下のいずれかまたは複数の方法で事前にお知らせします。
              </p>
              <div className="bg-black/30 border border-white/10 rounded-lg p-4 space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-cyan-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white/80 text-sm font-bold">メール通知</p>
                    <p className="text-white/50 text-xs mt-0.5">ご登録のメールアドレス宛に、変更内容の概要と変更後のポリシーへのリンクをお送りします。</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-notification-3-line text-cyan-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white/80 text-sm font-bold">サービス内通知（アプリ内バナー）</p>
                    <p className="text-white/50 text-xs mt-0.5">本サービスのトップ画面またはマイページに、変更内容を告知するバナーまたはお知らせを表示します。</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-file-text-line text-cyan-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white/80 text-sm font-bold">本ページへの掲載</p>
                    <p className="text-white/50 text-xs mt-0.5">変更後のポリシーを本ページに掲載し、ページ上部の「最終更新日」を更新します。</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <p className="font-bold text-white/90 mb-1">8.3 軽微な変更</p>
              <p>
                誤字・脱字の修正、条文の整理など、利用者の権利に実質的な影響を与えない軽微な変更については、事前通知なく本ページへの掲載のみで変更が効力を生じる場合があります。
              </p>
            </div>

            <div>
              <p className="font-bold text-white/90 mb-1">8.4 変更後の利用について</p>
              <p>
                変更の効力発生日以降に本サービスを継続してご利用いただいた場合、変更後のポリシーに同意したものとみなされます。変更内容にご同意いただけない場合は、本サービスの利用を停止し、第7条のお問い合わせ窓口までご連絡ください。
              </p>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
}
